import { IonPage } from '@ionic/react';
import { EmptyNewBusiness } from 'model';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useCreateBusinessMutation } from '../../api/BusinessApi';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { useLoading } from '../../hooks/useQuirkLoading';

export const CreateBusiness: React.FC = () => {
	const [createBusiness, { isLoading: updateIsLoading }] = useCreateBusinessMutation();
	useLoading({
		isLoading: updateIsLoading,
		message: 'Creating business...'
	});
	const history = useHistory();
	useEffect(() => {
		const create = async () => {
			const business = await createBusiness({ business: { ...EmptyNewBusiness, draft: true } });
			if ('error' in business) {
				history.go(-1);
			} else if (business.data) {
				history.replace(`/main/bus/edit/${business.data._id}`);
			}
		};
		create();
	}, [createBusiness, history]);

	return (
		<IonPage>
			<QuirkIonContent>
				<></>
			</QuirkIonContent>
		</IonPage>
	);
};
